<template>
  <b-badge :variant="badgeVariant" :pill="badgePill">{{ badgeText }}</b-badge>
</template>

<script>
export default {
  name: 'AdminOrderBadge',
  props: {
    type: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    pill: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    badgeType() {
      return this.type;
    },
    badgePill() {
      return this.pill;
    },
    badgeValue() {
      return this.value;
    },
    badgeText() {
      return this.text;
    },
    badgeVariant() {
      if (this.badgeType === 'status') {
        switch (this.badgeValue) {
          case 'pending':
            return 'info';
          case 'shipped':
            return 'primary';
          case 'accepted':
            return 'success';
          case 'delivered':
            return 'dark';
          case 'declined':
            return 'warning'
          case 'rejected':
          case 'cancelled':
            return 'danger';
        }
      } else if (this.badgeType === 'source') {
        switch (this.badgeValue) {
          case 'gl':
            return 'success';
          case 'll':
            return 'primary';
          case 'm':
            return 'secondary';
        }
      }

      return 'grey-6';
    }
  }
}
</script>
